import React, { useState, useEffect, useCallback } from "react";
import { Table, Input, Select, Button, Card, Space, Modal, Tag, message, Tooltip, Drawer, Empty, Typography, DatePicker } from "antd";
import { CSVLink } from "react-csv";
import { EditOutlined, ReloadOutlined, VideoCameraOutlined, EnvironmentOutlined, BookOutlined, SaveOutlined, CheckCircleOutlined, HomeOutlined, QuestionOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import axios from "axios";
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import withRoleAccess from "../../hoc/withRoleAccess";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jwtDecode } from "jwt-decode";
import { 
  faFileExcel, 
  faSearch, 
  faCalendarAlt, 
  faChalkboardTeacher,
  faBookOpen 
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import dayjs from 'dayjs';
import "./Classes.css";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;

const AllClassList = () => {
  const { t, i18n } = useTranslation();
  const [classes, setClasses] = useState([]);
  const [attendanceMap, setAttendanceMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [editingTeacherId, setEditingTeacherId] = useState(null);
  const [editedTeacherId, setEditedTeacherId] = useState('');
  const [editingDateId, setEditingDateId] = useState(null);
  const [editedDate, setEditedDate] = useState("");
  const [classrooms, setClassrooms] = useState([]);
  const [editingClassroomId, setEditingClassroomId] = useState(null);
  const [editedClassroomId, setEditedClassroomId] = useState('');
  const [editingSubjectId, setEditingSubjectId] = useState(null);
  const [editedSubjectId, setEditedSubjectId] = useState('');
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


  const [editingPlatformId, setEditingPlatformId] = useState(null);
  const [editedPlatform, setEditedPlatform] = useState(null);

  const [videoLinkModalOpen, setVideoLinkModalOpen] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [videoClassId, setVideoClassId] = useState(null);
  const [existingVideoLink, setExistingVideoLink] = useState(null);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [editingTimeId, setEditingTimeId] = useState(null);
  const [editedTime, setEditedTime] = useState("");
  const [confirmingClassId, setConfirmingClassId] = useState(null);
  const [editingHourId, setEditingHourId] = useState(null);
  const [editedHour, setEditedHour] = useState(null);
  const [pendingChange, setPendingChange] = useState(null);

  //Attendance
  const [attendanceDrawerOpen, setAttendanceDrawerOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [registeredStudents, setRegisteredStudents] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [homework, setHomework] = useState({});
  const [savedAttendances, setSavedAttendances] = useState({});
  const [editMode, setEditMode] = useState({});
  const [savingInProgress, setSavingInProgress] = useState(false);
  const [submittedSchedules, setSubmittedSchedules] = useState([]);


  const [dateRange, setDateRange] = useState({
    startDate: moment().utcOffset('+07:00').format('YYYY-MM-DD'),
    endDate: moment().utcOffset('+07:00').format('YYYY-MM-DD'),
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 200,
    total: 0
  });

   const token = localStorage.getItem("token");
      let userRole = null;
      let userBranchId = null;
  
      if (token) {
      try {
          const decoded = jwtDecode(token);
          userRole = decoded.role;
          // Support both formats just in case
          userBranchId = decoded.branchId || decoded.branch_id || null;
      } catch (err) {
          console.error("Invalid token", err);
      }
      }

  // Admin-confirmed classes: only a superadmin may change date/time/hours
  const isScheduleLocked = (record) =>
    record.adminapprove === "adminconfirm" && userRole !== "superadmin";

  const API_URL = process.env.REACT_APP_API_URL;


// Time options 08:00–23:00 every 15 mins
  const timeOptions = Array.from({ length: (23 - 8 + 1) * 4 }, (_, index) => {
    const hour = 8 + Math.floor(index / 4);
    const minutes = (index % 4) * 15;
    const label = `${hour.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
    return { label, value: label + ":00" }; // stored as HH:mm:ss
  });

  // Hour options 0:15 → 3:00 (in minutes)
 const hourOptions = Array.from({ length: 12 }, (_, index) => {
  const minutes = (index + 1) * 15; // 15, 30, …, 180
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return {
    label: `${h}h ${m.toString().padStart(2, "0")}m`,
    value: minutes
  };
});

  const calculateEndTime = (startTime, duration) => {
    if (!duration) return 'N/A';
    
    let durationMinutes = 0;
    if (typeof duration === 'string') {
      if (duration.includes('h') && duration.includes('m')) {
        const hourMatch = duration.match(/(\d+)h/);
        const minuteMatch = duration.match(/(\d+)m/);
        durationMinutes = (hourMatch ? parseInt(hourMatch[1]) * 60 : 0) + 
                         (minuteMatch ? parseInt(minuteMatch[1]) : 0);
      } else {
        durationMinutes = parseInt(duration) || 60;
      }
    }
    
    return moment(startTime, 'HH:mm').add(durationMinutes, 'minutes').format('HH:mm');
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat(i18n.language, options).format(date).toUpperCase();
  };

  const formatDateString = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  const date = new Date(year, month - 1, day); // local date, no timezone shift
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Intl.DateTimeFormat("en-GB", options).format(date); 
};


  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  };

  const formatScheduleHour = (scheduleHourString) => {
    if (!scheduleHourString) return "-";
    try {
      const [hours, minutes] = scheduleHourString.split(' ')
        .map((value, index) => (index === 0 ? parseInt(value) : parseInt(value)));
      if (isNaN(hours) || isNaN(minutes)) return scheduleHourString;
      return `${hours}:${minutes.toString().padStart(2, '0')}`;
    } catch (error) {
      console.error('Error formatting schedule hour:', error);
      return scheduleHourString;
    }
  };

  useEffect(() => {
  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/branch`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranches(res.data);
    } catch (err) {
      console.error("Failed to fetch branches", err);
    }
  };

  fetchBranches();
}, [API_URL]);

const fetchClasses = useCallback(async () => {
  if (!dateRange?.startDate || !dateRange?.endDate) {
    console.warn("⚠️ Missing dateRange when calling fetchClasses");
    return;
  }

  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("❌ No token found");
      setLoading(false);
      return;
    }

    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id || null;

    const params = {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    };

    if (role === "admin" && branchId) {
      params.branchId = branchId;
    }

    if (role === "superadmin" && selectedBranch) {
      params.branchFilter = selectedBranch;
    }

    // Fetch classes and attendance in parallel
    const [classesResponse, attendanceResponse] = await Promise.all([
      axios.get(`${API_URL}/classes/all-class-list`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }),
      axios.get(`${API_URL}/classes/attendance-by-date-range`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        },
      }),
    ]);

    const unique = [...new Map(
      (classesResponse.data || []).map(item => [item.classid, item])
    ).values()];
    setClasses(unique);

    // Build attendance map: { classid: { student_id: status } }
    const attendanceData = {};
    (attendanceResponse.data || []).forEach((att) => {
      if (!attendanceData[att.classid]) {
        attendanceData[att.classid] = {};
      }
      attendanceData[att.classid][att.student_id] = att.status;
    });
    setAttendanceMap(attendanceData);

  } catch (error) {
    console.error("❌ Error fetching data:", error);
  } finally {
    setLoading(false);
  }
}, [API_URL, dateRange, selectedBranch]);



// Fetch teachers
const fetchTeachers = useCallback(async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/teachers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // Access the teachers array inside response.data
    const teachersArray = response.data.teachers || [];
    setTeachers(teachersArray.filter((teacher) => teacher.status === "active"));
  } catch (error) {
    console.error("Error fetching teachers:", error);
  }
}, [API_URL]);


// Fetch subjects
const fetchSubjects = useCallback(async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/subjects`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setSubjects(response.data);
  } catch (error) {
    console.error("Error fetching subjects:", error);
  }
}, [API_URL]);

useEffect(() => {
  fetchClasses();
  fetchTeachers();
  fetchSubjects(); 
}, [fetchClasses, fetchTeachers, fetchSubjects]);



useEffect(() => {
  const fetchClassrooms = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/classrooms`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const classroomsData = response.data || [];

      // ✅ Still filter only available ones
      const availableClassrooms = classroomsData.filter(
        classroom => classroom.availability === true
      );

      // ✅ Sort nicely by classroom number
      const sortedClassrooms = availableClassrooms.sort((a, b) =>
        a.number.localeCompare(b.number, undefined, { numeric: true, sensitivity: 'base' })
      );

      setClassrooms(sortedClassrooms);
    } catch (error) {
      console.error('Error fetching classrooms:', error);
    }
  };

  fetchClassrooms();
}, [API_URL]);


const openAttendanceDrawer = async (classItem) => {
  setSelectedClass(classItem);
  setAttendanceDrawerOpen(true);

  try {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    // ✅ Directly use data from /classes/today
    const studentIds = classItem.student_ids
      ? classItem.student_ids.split(',').map(id => id.trim())
      : [];
    const studentNames = classItem.student_nicknames
      ? classItem.student_nicknames.split(',').map(name => name.trim())
      : [];

    const combinedStudents = studentIds.map((id, index) => ({
      student_id: parseInt(id, 10),
      nickname: studentNames[index] || `Student ${id}`,
    }));


    setRegisteredStudents(combinedStudents);

    // ✅ Fetch existing attendance data (optional, keep this)
    const attendanceResponse = await axios.get(
      `${API_URL}/attendance/${classItem.classid}`,
      { headers }
    );

    const savedData = {};
    attendanceResponse.data.forEach(record => {
      savedData[record.student_id] = record;
    });

    setSavedAttendances(savedData);

    // ✅ Warn if there are no students
    if (combinedStudents.length === 0) {
      message.warning('No students found in class data');
    }
  } catch (error) {
    console.error('❌ Error loading attendance data:', error);
    message.error('Failed to load attendance data');
  }
};


  // Attendance Handlers
  const handleAttendanceChange = (studentId, field, value) => {
    setAttendance(prev => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [field]: value
      }
    }));
  };

  const handleHomeworkChange = (studentId, value) => {
    setHomework(prev => ({
      ...prev,
      [studentId]: value
    }));
  };

  const handleSaveAttendance = async (studentId) => {
    if (!attendance[studentId]?.status) {
      message.warning('Please select an attendance status');
      return;
    }

    setSavingInProgress(true);
    try {
      const token = localStorage.getItem('token');
      const attendanceData = [{
        student_id: studentId,
        status: attendance[studentId].status,
        comment: attendance[studentId].comment || '',
        homework: homework[studentId] || 'N/A'
      }];

      await axios.post(
        `${API_URL}/attendance`,
        {
          groupid: selectedClass.groupid,
          classid: selectedClass.classid,
          attendance: attendanceData
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSavedAttendances(prev => ({
        ...prev,
        [studentId]: {
          ...attendance[studentId],
          homework: homework[studentId],
          timestamp: new Date().toISOString()
        }
      }));

      setAttendance(prev => {
        const newState = { ...prev };
        delete newState[studentId];
        return newState;
      });
      setHomework(prev => {
        const newState = { ...prev };
        delete newState[studentId];
        return newState;
      });

      message.success('Attendance saved successfully');
      await fetchClasses();
    } catch (error) {
      console.error('Error saving attendance:', error);
      message.error('Failed to save attendance');
    } finally {
      setSavingInProgress(false);
    }
  };

  const handleEdit = (studentId) => {
    const savedRecord = savedAttendances[studentId];
    setEditMode(prev => ({ ...prev, [studentId]: true }));
    setAttendance(prev => ({
      ...prev,
      [studentId]: {
        status: savedRecord.status,
        comment: savedRecord.comment || ''
      }
    }));
    setHomework(prev => ({
      ...prev,
      [studentId]: savedRecord.homework || 'N/A'
    }));
  };

  const handleUpdate = async (studentId) => {
    if (!attendance[studentId]?.status) {
      message.warning('Please select an attendance status');
      return;
    }

    setSavingInProgress(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API_URL}/attendance/${savedAttendances[studentId].attendance_id}`,
        {
          status: attendance[studentId].status,
          comment: attendance[studentId].comment || '',
          homework: homework[studentId] || 'N/A'
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSavedAttendances(prev => ({
        ...prev,
        [studentId]: {
          ...prev[studentId],
          status: attendance[studentId].status,
          comment: attendance[studentId].comment || '',
          homework: homework[studentId] || 'N/A',
          edited_at: new Date().toISOString()
        }
      }));

      setEditMode(prev => ({ ...prev, [studentId]: false }));
      message.success('Attendance updated successfully');

      await fetchClasses();
    } catch (error) {
      console.error('Error updating attendance:', error);
      message.error('Failed to update attendance');
    } finally {
      setSavingInProgress(false);
    }
  };

  const handleDeleteAttendanceInDrawer = async (studentId) => {
  const record = savedAttendances[studentId];
  if (!record?.attendance_id) return;

  Modal.confirm({
    title: t("Delete Attendance"),
    content: t("Are you sure you want to delete this attendance record?"),
    okText: t("Delete"),
    okType: "danger",
    cancelText: t("Cancel"),
    onOk: async () => {
      try {
        const token = localStorage.getItem("token");

        await axios.delete(
          `${API_URL}/attendance/${record.attendance_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // ✅ Remove locally so UI updates immediately
        setSavedAttendances(prev => {
          const next = { ...prev };
          delete next[studentId];
          return next;
        });

        setEditMode(prev => {
          const next = { ...prev };
          delete next[studentId];
          return next;
        });

        message.success(t("Attendance deleted"));

        // 🔁 Refresh class list so table updates
        await fetchClasses();
      } catch (err) {
        console.error("Failed to delete attendance:", err);
        message.error(t("Failed to delete attendance"));
      }
    }
  });
};


const openVideoLinkModal = async (classId) => {
  setVideoClassId(classId);
  setVideoLink("");
  setExistingVideoLink(null);
  setVideoLinkModalOpen(true);

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(`${API_URL}/video-meeting-links/${classId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (res.data.length > 0) {
      setExistingVideoLink(res.data[0].video_meeting_link);
      setVideoLink(res.data[0].video_meeting_link);
    }
  } catch (err) {
    console.error("Error fetching video link:", err);
  }
};

const saveVideoLink = async () => {
  if (!videoLink) {
    message.warning("Video link cannot be empty");
    return;
  }

  try {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    if (existingVideoLink) {
      // 🔥 UPDATE existing link
      await axios.put(
        `${API_URL}/video-meeting-links/${videoClassId}`,
        { video_meeting_link: videoLink },
        { headers }
      );
    } else {
      // 🔥 CREATE new link
      await axios.post(
        `${API_URL}/video-meeting-links`,
        {
          classid: videoClassId,
          video_meeting_link: videoLink,
        },
        { headers }
      );
    }

    message.success("Video link saved");

    // ⭐ Refresh table
    await fetchClasses();

    // Close modal
    setVideoLinkModalOpen(false);

  } catch (err) {
    console.error("Error saving video link:", err);
    message.error("Failed to save video link");
  }
};

const handleRefresh = async () => {
  message.loading({ content: t("Refreshing data..."), key: "refresh" });
  try {
    await fetchClasses();
    message.success({ content: t("Data refreshed"), key: "refresh", duration: 1 });
  } catch {
    message.error({ content: t("Failed to refresh"), key: "refresh" });
  }
};

const handleStudentConfirm = async (classId, currentConfirmStatus) => {
  const confirm = !currentConfirmStatus; // Toggle the status

  // Show confirmation dialog
  const userConfirmed = await new Promise((resolve) => {
    Modal.confirm({
      title: confirm ? t('Confirm Student') : t('Unconfirm Student'),
      content: confirm 
        ? t('Are you sure you want to confirm this student?')
        : t('Are you sure you want to unconfirm this student?'),
      okText: t('Yes'),
      cancelText: t('No'),
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });

  // If user clicked "No" or closed the modal, exit early
  if (!userConfirmed) {
    return;
  }

  setConfirmingClassId(classId);

  try {
    const token = localStorage.getItem('token');
    const url = `${API_URL}/classes/${classId}/student-confirm`;
    const payload = { confirm };
    const headers = { Authorization: `Bearer ${token}` };

    await axios.put(url, payload, { headers });

    message.success(
      confirm 
        ? t('studentConfirmedSuccessfully') || 'Student confirmed successfully'
        : t('studentUnconfirmedSuccessfully') || 'Student unconfirmed successfully'
    );

    // Refresh the classes list
    await fetchClasses();
  } catch (err) {
    console.error('[student-confirm] Error', {
      message: err?.message,
      status: err?.response?.status,
      data: err?.response?.data,
    });

    message.error(
      err?.response?.data?.message || 
      (confirm 
        ? t('Failed to confirm student')
        : t('Failed to unconfirm student')
      )
    );
  } finally {
    setConfirmingClassId(null);
  }
};


const handleEditDateClick = (classId, date) => {
  setEditingDateId(classId);
  setEditedDate(moment(date).format("DD-MM-YYYY"));
};

const handleSaveDateClick = (classId) => {
  const record = classes.find(c => c.classid === classId);
  const pc = { classId, field: 'date', value: editedDate, originalRecord: record, endpoint: 'default' };
  setPendingChange(pc);
  handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
};
  const handleClassroomChangeDropdown = (value) => {
    setEditedClassroomId(value);
  };

  const handleTeacherChangeDropdown = (value) => {
    setEditedTeacherId(value);
  };

  const handleEditClassroomClick = (classId, classroomId) => {
    setEditingClassroomId(classId);
    setEditedClassroomId(classroomId); 
  };

  const handleEditTeacherClick = (classId, teacherId) => {
    setEditingTeacherId(classId);
    setEditedTeacherId(teacherId); 
  };

  const handleSubjectChangeDropdown = (value) => {
    setEditedSubjectId(value);
  };
  
  const handleEditSubjectClick = (classId, subjectId) => {
    setEditingSubjectId(classId);
    setEditedSubjectId(subjectId); 
  };

  const showConfirmBeforeSave = ({ onOk, title = "Are you sure?", content = "Do you want to save the changes?" }) => {
    Modal.confirm({
      title: title,
      content: content,
      okText: 'Yes',
      cancelText: 'No',
      onOk, // if user clicks yes, execute the onOk function
    });
  };

const handleSaveTime = (classId) => {
  const record = classes.find(c => c.classid === classId);
  const pc = { classId, field: 'schedule_time', value: editedTime, originalRecord: record, endpoint: 'time-change' };
  setPendingChange(pc);
  handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
};


const handleSaveHour = (classId) => {
  const record = classes.find(c => c.classid === classId);
  const pc = { classId, field: 'schedule_hour', value: editedHour, originalRecord: record, endpoint: 'time-change' };
  setPendingChange(pc);
  handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
};


  const handleSaveClassroomClick = (classId) => {
    const record = classes.find(c => c.classid === classId);
    const pc = { classId, field: 'classroom_id', value: editedClassroomId, originalRecord: record, endpoint: 'default' };
    setPendingChange(pc);
    handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
  };


  const handleSaveTeacherClick = (classId) => {
    const record = classes.find(c => c.classid === classId);
    const pc = { classId, field: 'teacher_id', value: editedTeacherId, originalRecord: record, endpoint: 'default' };
    setPendingChange(pc);
    handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
  };


  const handleSaveSubjectClick = (classId) => {
    const record = classes.find(c => c.classid === classId);
    const pc = { classId, field: 'subjectid', value: editedSubjectId, originalRecord: record, endpoint: 'default' };
    setPendingChange(pc);
    handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
  };

  // ✨ Start editing
const handleEditPlatformClick = (classId, platform) => {
  setEditingPlatformId(classId);
  setEditedPlatform(platform);
};

// ✨ Save platform
const handleSavePlatformClick = (classId) => {
  const record = classes.find(c => c.classid === classId);
  const pc = { classId, field: 'platform', value: editedPlatform, originalRecord: record, endpoint: 'default' };
  setPendingChange(pc);
  handleChangeSubmit('admin adjust', 'Admin adjustment', pc);
};

const handleChangeSubmit = async (reason, note, pendingChangeArg = null) => {
  const pc = pendingChangeArg || pendingChange;
  if (!pc) return;
  const { classId, field, value, originalRecord, endpoint } = pc;
  const token = localStorage.getItem('token');

  try {
    // Build the PUT body and URL based on field/endpoint
    const bodyMap = {
      teacher_id: { teacher_id: value },
      subjectid: { subjectid: value },
      date: { date: value },
      schedule_time: { schedule_time: value },
      schedule_hour: { schedule_hour: value },
      platform: { platform: value },
      classroom_id: { classroom_id: value },
    };

    const url = endpoint === 'time-change'
      ? `${API_URL}/classes/time-change/${classId}`
      : `${API_URL}/classes/${classId}`;

    await axios.put(url, bodyMap[field], {
      headers: { Authorization: `Bearer ${token}` }
    });

    // Parse schedule_hour which may be "1h 30m" string or raw minutes
    const parseHourToMinutes = (h) => {
      if (typeof h === 'number') return h;
      if (typeof h === 'string') {
        const match = h.match(/(\d+)h\s*(\d+)m/);
        if (match) return parseInt(match[1]) * 60 + parseInt(match[2]);
        return parseInt(h) || 0;
      }
      return 0;
    };

    // Calculate times for logging
    const scheduleTime = field === 'schedule_time' ? value : originalRecord.schedule_time;
    const origHourMins = parseHourToMinutes(originalRecord.schedule_hour);
    const newHourMins = field === 'schedule_hour' ? parseHourToMinutes(value) : origHourMins;
    const originalDate = originalRecord.date ? moment(originalRecord.date).format('YYYY-MM-DD') : null;
    const originalStartTime = originalRecord.schedule_time || null;
    const originalEndTime = originalRecord.schedule_time
      ? moment(originalRecord.schedule_time, 'HH:mm:ss').add(origHourMins, 'minutes').format('HH:mm:ss')
      : null;
    const newEndTime = moment(scheduleTime, 'HH:mm:ss').add(newHourMins, 'minutes').format('HH:mm:ss');

    // Log the change
    await axios.post(
      `${API_URL}/class-change/newlogs`,
      {
        classid: classId,
        teacherid: field === 'teacher_id' ? value : originalRecord.teacher_id,
        originaldate: originalDate,
        originalstarttime: originalStartTime,
        originalendtime: originalEndTime,
        newdate: field === 'date' ? value : originalDate,
        newstarttime: field === 'schedule_time' ? value : originalStartTime,
        newendtime: newEndTime,
        changereason: reason || 'class_changed',
        note: note || `Changed ${field}`,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    message.success("Updated successfully");

    // Reset all editing states
    setEditingTeacherId(null);
    setEditingSubjectId(null);
    setEditingDateId(null);
    setEditingTimeId(null);
    setEditingHourId(null);
    setEditingPlatformId(null);
    setEditingClassroomId(null);
    setEditedTeacherId('');
    setEditedSubjectId('');
    setEditedDate('');
    setEditedTime('');
    setEditedHour(null);
    setEditedPlatform(null);
    setEditedClassroomId('');
    setPendingChange(null);
    fetchClasses();
  } catch (error) {
    console.error("Error updating class:", error);
    message.error(error.response?.data?.message || "Failed to update");
  }
};

  const filteredClasses = classes
  .filter((classItem) => {
    // Convert class date to Bangkok time
    const classDate = moment(classItem.date).utcOffset('+07:00');
    const startDate = moment(dateRange.startDate).utcOffset('+07:00');
    const endDate = moment(dateRange.endDate).utcOffset('+07:00');
    
    const isInDateRange = 
      classDate.isSameOrAfter(startDate, 'day') && 
      classDate.isSameOrBefore(endDate, 'day');
    
    const isSearchMatch =
      !searchTerm ||
      classItem.subject_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      classItem.class_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      classItem.student_nicknames?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const isTeacherMatch =
      !selectedTeacher || classItem.teacher_id === selectedTeacher;

    const isBranchMatch =
      !selectedBranch || String(classItem.branch_id) === String(selectedBranch);

    return isInDateRange && isSearchMatch && isTeacherMatch && isBranchMatch;
  })
  .sort((a, b) => {
    // Sort by date and then by schedule_time
    const dateComparison = new Date(a.date) - new Date(b.date);
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return moment(a.schedule_time, "HH:mm:ss").diff(
      moment(b.schedule_time, "HH:mm:ss")
    );
  });

// Add this useEffect to reset pagination when filters change
useEffect(() => {
  setPagination(prev => ({
    ...prev,
    current: 1, // Reset to page 1 when filters change
    total: filteredClasses.length
  }));
}, [searchTerm, selectedTeacher, selectedBranch, dateRange, filteredClasses.length]);

const handleClearFilters = () => {
  setSearchTerm("");
  setSelectedTeacher("");
  setSelectedBranch(null);
  setDateRange({
    startDate: moment().utcOffset('+07:00').format('YYYY-MM-DD'),
    endDate: moment().utcOffset('+07:00').format('YYYY-MM-DD'),
  });
  setPagination(prev => ({ ...prev, current: 1 }));
};

  const handleTableChange = (newPagination) => {
    setPagination(prev => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize
    }));
  };

  const getCurrentPageData = () => {
    const { current, pageSize } = pagination;
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return filteredClasses.slice(startIndex, endIndex);
  };


// CSV Data for Export
const csvData = filteredClasses.map((classItem) => {
  // Pair each student with their attendance status for this specific class
  const studentIds = classItem.student_ids
    ? classItem.student_ids.split(',').map((s) => s.trim()).filter(Boolean)
    : [];
  const studentNames = classItem.student_nicknames
    ? classItem.student_nicknames.split(',').map((s) => s.trim())
    : [];
  const classAttendance = attendanceMap[classItem.classid] || {};

  const perStudent = studentIds.map((id, idx) => {
    const name = studentNames[idx] || `#${id}`;
    const status = classAttendance[id] || classAttendance[parseInt(id, 10)] || 'No Record';
    return `${name}: ${status}`;
  });

  const countOf = (s) => studentIds.filter((id) => {
    const status = classAttendance[id] || classAttendance[parseInt(id, 10)];
    return status === s;
  }).length;

  return {
    Branch: classItem.name || "N/A",
    "Branch ID": classItem.branch_id || "N/A",
    Platform: classItem.platform || "N/A",
    Date: formatDate(classItem.date),
    Day: new Date(classItem.date).toLocaleDateString("en-US", { weekday: "long" }),
    "Class Code": classItem.class_code,
    "Start Time": formatTime(classItem.schedule_time),
    "End Time": formatTime(classItem.end_time),
    Hours: formatScheduleHour(classItem.schedule_hour),
    Subject: classItem.subject_name,
    Tutor:
      teachers.find((teacher) => teacher.userid === classItem.teacher_id)?.nickname || "N/A",
    Room: classItem.classroom_number,
    Type: classItem.isprivate ? "Private" : "Group",
    Status: classItem.status || "N/A",
    Attendance: perStudent.join(" | "),
    "Present Count": countOf("Present"),
    "Late Count": countOf("Late"),
    "Absent Count": countOf("Absent"),
    "To Be Rescheduled Count": countOf("To be rescheduled"),
  };
});


    const branchColors = {
  1: "blue",
  2: "green",
  3: "magenta", 
};

  const columns = [
 

{
  title: t("Confirm"),
  dataIndex: "student_confirm",
  key: "student_confirm",
  width: 120,
  align: "center",
  render: (confirmed, record) => {
    const isLoading = confirmingClassId === record.classid;

    const handleToggleConfirm = async () => {
      const action = confirmed ? "unconfirm" : "confirm";

      Modal.confirm({
        title: confirmed
          ? t("Revoke Student Confirmation")
          : t("Confirm Student Attendance"),
        content: confirmed
          ? t("Are you sure you want to revoke this student's confirmation?")
          : t("Are you sure you want to confirm this student's attendance?"),
        okText: t("Yes"),
        cancelText: t("No"),
        okType: confirmed ? "danger" : "primary",
        onOk: () => handleStudentConfirm(record.classid, confirmed),
      });
    };

    return (
      <Tooltip
        title={
          confirmed
            ? t("Click to unconfirm student attendance")
            : t("Click to confirm student attendance")
        }
      >
        <Button
          shape="circle"
          type={confirmed ? "default" : "primary"}
          icon={
            confirmed ? (
              <CheckOutlined style={{ color: "green" }} />
            ) : (
              <CloseOutlined style={{ color: "red" }} />
            )
          }
          onClick={handleToggleConfirm}
          loading={isLoading}
          disabled={isLoading}
          style={{
            border: confirmed ? "1px solid #52c41a" : "1px solid #ff4d4f",
            backgroundColor: confirmed ? "#f6ffed" : "#fff1f0",
            transition: "all 0.2s ease",
          }}
        />
      </Tooltip>
    );
  },
},
{
  title: t("Branch"),
  key: "branch",
  dataIndex: "branch_id",
  width: 120, // 👈 set a fixed width
  ellipsis: true, // 👈 prevent header wrapping
  render: (_, record) => {
    const branchId = record.branch_id;
    const color = branchColors[branchId] || "default";
    return record.name ? (
      <Tag color={color}>{record.name}</Tag>
    ) : (
      <Tag>-</Tag>
    );
  },
},

{
  title: t("Date"),
  dataIndex: "date",
  key: "date",
  width: 160,
  ellipsis: true,
  render: (date, record) => {
    const isEditing = editingDateId === record.classid && !isScheduleLocked(record);

    if (!isEditing) {
      return (
        <Space>
          <Button
            type="link"
            icon={<FontAwesomeIcon icon={faCalendarAlt} />}
            onClick={() => {
              if (!isScheduleLocked(record)) {
                handleEditDateClick(record.classid, record.date);
              }
            }}
            style={{ padding: 0, height: "auto" }}
            disabled={isScheduleLocked(record)}
          />
          <span>{moment(date).format("DD MMM YYYY")}</span>
        </Space>
      );
    }

    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <input
          type="date"
          value={editedDate}
          onChange={(e) => setEditedDate(e.target.value)}
          style={{
            width: "100%",
            padding: "4px 11px",
            border: "1px solid #d9d9d9",
            borderRadius: "2px",
            fontSize: "14px",
          }}
        />
        <Space>
          <Button
            type="primary"
            size="small"
            onClick={() => handleSaveDateClick(record.classid)}
          >
            {t("Save")}
          </Button>
          <Button size="small" onClick={() => setEditingDateId(null)}>
            {t("Cancel")}
          </Button>
        </Space>
      </Space>
    );
  },
},

    {
      title: t("Day"),
      dataIndex: "day",
      key: "day",
      width: 100,
      render: (_, record) => (
        <span className="day-cell">
          {new Date(record.date).toLocaleDateString("en-US", { weekday: "long" })}
        </span>
      ),
    },
{
  title: t("Time"),
  key: "time",
  width: 150,
  render: (_, record) => {
    return editingTimeId === record.classid && !isScheduleLocked(record) ? (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Select
          value={editedTime || record.schedule_time}
          onChange={setEditedTime}
          style={{ width: 120 }}
          options={timeOptions}
          showSearch
        />
        <Space>
          <Button size="small" type="primary" onClick={() => handleSaveTime(record.classid)}>
            {t("Save")}
          </Button>
          <Button size="small" onClick={() => setEditingTimeId(null)}>
            {t("Cancel")}
          </Button>
        </Space>
      </Space>
    ) : (
      <Space>
        {!isScheduleLocked(record) && (
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => {
              setEditingTimeId(record.classid);
              setEditedTime(record.schedule_time);
            }}
          />
        )}
        <span>
          {moment(record.schedule_time, "HH:mm:ss").format("HH:mm")} -{" "}
          {moment(record.end_time, "HH:mm:ss").format("HH:mm")}
        </span>
      </Space>
    );
  }
},

    {
      title: t("Hours"),
  dataIndex: "schedule_hour",
  key: "schedule_hour",
  width: 100,
 align: "center",
 render: (scheduleHour, record) => {
    if (!scheduleHour) return "-";

   if (editingHourId === record.classid && !isScheduleLocked(record)) {
      return (
       <Space direction="vertical" style={{ width: "100%" }}>
          <Select
            value={editedHour ?? scheduleHour}
           onChange={setEditedHour}
            style={{ width: 120 }}
           options={hourOptions}
          />
          <Space>
            <Button size="small" type="primary" onClick={() => handleSaveHour(record.classid)}>
              {t("Save")}
            </Button>
            <Button size="small" onClick={() => setEditingHourId(null)}>
              {t("Cancel")}
            </Button>
          </Space>
       </Space>
      );
    }

    return (
      <Space>
        {!isScheduleLocked(record) && (
         <Button
            type="link"
           icon={<EditOutlined />}
            onClick={() => {
             setEditingHourId(record.classid);
              setEditedHour(scheduleHour);
           }}
         />
       )}
        <span>{formatScheduleHour(scheduleHour)}</span>
      </Space>
   );
  },
 },
        {
      title: t("course"),
      dataIndex: "class_code",
      key: "class_code",
      width: 250,
      render: (text) => <div className="wrapped-cell">{text}</div>,
    },
{
  title: t("Students"),
  dataIndex: "student_nicknames",
  key: "student_nicknames",
  width: 180,
  render: (_, record) => {
    const names = record.student_nicknames
      ? record.student_nicknames.split(",").map(n => n.trim())
      : [];

    const studentIds = record.student_ids
      ? record.student_ids.split(",").map(id => id.trim())
      : [];

    if (names.length === 0) {
      return <Tag color="default">{t("No Students")}</Tag>;
    }

    // Get attendance for this class
    const classAttendance = attendanceMap[record.classid] || {};

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {names.map((name, index) => {
            const studentId = studentIds[index];
            const status = classAttendance[studentId]; // Get status from map

            let color = "default";
            let label = `${name} - Pending`;

            if (status === "Present") {
              color = "green";
              label = `${name} - Present`;
            } else if (status === "Late") {
              color = "orange";
              label = `${name} - Late`;
            } else if (status === "Absent") {
              color = "red";
              label = `${name} - Absent`;
            } else if (status === "To be rescheduled") {
              color = "purple";
              label = `${name} - To be rescheduled`;
            }

            return (
              <Tag
                key={`${record.classid}-${studentId}`}
                color={color}
                style={{ fontSize: 12, padding: "2px 8px" }}
              >
                {label}
              </Tag>
            );
          })}
        </div>

        <Button
          type="primary"
          size="small"
          onClick={() => openAttendanceDrawer(record)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            borderRadius: 4,
            padding: "0 8px",
            width: "fit-content",
          }}
        >
          <CheckCircleOutlined />
          {t("Attendance")}
        </Button>
      </div>
    );
  },
},
{
  title: t("platform"),
  dataIndex: "platform",
  key: "platform",
  width: 140,
  render: (platform, record) => {
    const isEditing = editingPlatformId === record.classid;

    const PLATFORM_OPTIONS = [
      { value: "online", label: t("online"), icon: <VideoCameraOutlined /> },
      { value: "onsite", label: t("onsite"), icon: <EnvironmentOutlined /> },
      { value: "athome", label: t("athome"), icon: <HomeOutlined /> },
    ];

    const getPlatformConfig = (p) => {
      switch (p) {
        case "online":
          return { text: t("online"), icon: <VideoCameraOutlined />, bg: "#E6F4FF", border: "#91CAFF", color: "#0958D9" };
        case "onsite":
          return { text: t("onsite"), icon: <EnvironmentOutlined />, bg: "#F6FFED", border: "#B7EB8F", color: "#389E0D" };
        case "athome":
          return { text: t("athome"), icon: <HomeOutlined />, bg: "#FFF7E6", border: "#FFD591", color: "#D48806" };
        default:
          return { text: p || "-", icon: <QuestionOutlined />, bg: "#F0F0F0", border: "#D9D9D9", color: "#595959" };
      }
    };

    const config = getPlatformConfig(platform);

    // VIEW MODE
    if (!isEditing) {
      return (
        <span
          onClick={() => {
            if (record.adminapprove !== "adminconfirm") {
              handleEditPlatformClick(record.classid, platform);
            }
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 8px",
            borderRadius: 6,
            fontSize: 12,
            background: config.bg,
            border: `1px solid ${config.border}`,
            color: config.color,
            cursor: record.adminapprove === "adminconfirm" ? "not-allowed" : "pointer",
            opacity: record.adminapprove === "adminconfirm" ? 0.6 : 1,
          }}
        >
          {config.icon} {config.text}
        </span>
      );
    }

    // EDIT MODE
    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Select
          value={editedPlatform}
          onChange={setEditedPlatform}
          style={{ width: "100%" }}
        >
          {PLATFORM_OPTIONS.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.icon} {opt.label}
            </Option>
          ))}
        </Select>

        <Space>
          <Button
            type="primary"
            size="small"
            onClick={() => handleSavePlatformClick(record.classid)}
          >
            {t("Save")}
          </Button>
          <Button size="small" onClick={() => setEditingPlatformId(null)}>
            {t("Cancel")}
          </Button>
        </Space>
      </Space>
    );
  },
},

{
  title: "Video Link",
  key: "video_link",
  width: 150,
  render: (_, record) => {
    const link = record.video_meeting_link;

    if (link) {
      const normalizedLink =
        link.startsWith("http://") || link.startsWith("https://")
          ? link
          : `https://${link}`;

      return (
        <Button
          type="link"
          onClick={() => openVideoLinkModal(record.classid)}
          style={{ padding: 0, display: "flex", alignItems: "center", gap: "6px" }}
        >
          <EditOutlined/>

          <a
            href={normalizedLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
            onClick={(e) => e.stopPropagation()} // avoid triggering edit
          >
            Open Link
          </a>
        </Button>
      );
    }

    return (
      <Button
        type="default"
        size="small"
        icon={<VideoCameraOutlined />}
        onClick={() => openVideoLinkModal(record.classid)}
      >
        Add Link
      </Button>
    );
  }
},
    {
      title: t("Subject"),
      dataIndex: "subject_name",
      key: "subject_name",
      width: 250,
      render: (text, record) => {
        return editingSubjectId === record.classid && record.adminapprove !== 'adminconfirm' ? (
          <Space direction="vertical" style={{ width: '100%' }}>
            <Select
              value={editedSubjectId || undefined}
              onChange={handleSubjectChangeDropdown}
              style={{ width: '100%' }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {subjects.map((subject) => (
                <Option key={subject.subjectid} value={subject.subjectid}>
                  {subject.title}
                </Option>
              ))}
            </Select>
            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => handleSaveSubjectClick(record.classid)}
              >
                {t("Save")}
              </Button>
              <Button
                size="small"
                onClick={() => setEditingSubjectId(null)}
              >
                {t("Cancel")}
              </Button>
            </Space>
          </Space>
        ) : (
          <Space>
            {/* Swap: Button first, then Subject Name */}
            {record.adminapprove !== 'adminconfirm' && ( 
              <Button
                type="link"
                icon={<FontAwesomeIcon icon={faBookOpen} />}
                onClick={() => handleEditSubjectClick(record.classid, record.subject_id)}
                style={{ padding: '0', height: 'auto' }}
              />
            )}
            <span>{text || t("N/A")}</span>
          </Space>
        );
      },
    },
    {
      title: t("Tutor"),
      dataIndex: "teacher_id",
      key: "teacher_id",
      width: 180,
      render: (teacherId, record) => {
        return editingTeacherId === record.classid && record.adminapprove !== 'adminconfirm' ? (
          <Space direction="vertical" style={{ width: '100%' }}>
            <Select
              value={editedTeacherId || undefined}
              onChange={handleTeacherChangeDropdown}
              style={{ width: '100%' }}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            >
              {teachers.map((teacher) => (
                <Option
                  key={teacher.userid}
                  value={teacher.userid}
                  label={`${teacher.nickname} ${teacher.firstname}`}
                >
                  {teacher.nickname} {teacher.firstname}
                </Option>
              ))}
            </Select>
            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => handleSaveTeacherClick(record.classid)}
              >
                {t("Save")}
              </Button>
              <Button
                size="small"
                onClick={() => setEditingTeacherId(null)}
              >
                {t("Cancel")}
              </Button>
            </Space>
          </Space>
        ) : (
          <Space>
            {/* Button first, then tutor name */}
            {record.adminapprove !== 'adminconfirm' && ( // 🔥 Only show edit button if status is not approved
              <Button
                type="link"
                icon={<FontAwesomeIcon icon={faChalkboardTeacher} />}
                onClick={() => handleEditTeacherClick(record.classid, record.teacher_id)}
                style={{ padding: '0', height: 'auto' }}
              />
            )}
            <span>
              {teachers.find((teacher) => teacher.userid === teacherId)?.nickname || t("N/A")}
            </span>
          </Space>
        );
      },
    },    
    {
      title: t("Room"),
      dataIndex: "classroom_number",
      key: "classroom_number",
      width: 150,
      align: "center",
      render: (_, record) => {
        return editingClassroomId === record.classid ? (
          <Space direction="vertical">
            
          <Select
            value={editedClassroomId || undefined}
            onChange={handleClassroomChangeDropdown}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="label"   // ✅ this is key
          >
            {classrooms.map((classroom) => (
              <Option
                key={classroom.classroomid}
                value={classroom.classroomid}
                label={`${classroom.branch_name || ""} ${classroom.number}`} // ✅ string label
              >
                ({classroom.branch_name ? classroom.branch_name.charAt(0).toUpperCase() : "?"}) {classroom.number}
              </Option>
            ))}
          </Select>

            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => handleSaveClassroomClick(record.classid)}
              >
                {t("Save")}
              </Button>
              <Button
                size="small"
                onClick={() => setEditingClassroomId(null)}
              >
                {t("Cancel")}
              </Button>
            </Space>
          </Space>
        ) : (
          <Space>
            <span>({record.name ? record.name.charAt(0) : t("N/A")})</span>
            <span>{record.classroom_number || t("N/A")}</span>

            <Button
                type="link"
                onClick={() => handleEditClassroomClick(record.classid, record.classroom_id)}
                icon={<EditOutlined />}
              />
          </Space>
        );
      },
    },     

 {
  title: t("Admin Confirm"),
  dataIndex: "adminapprove",
  key: "adminapprove",
  width: 120,
  align: "center",
  render: (value) => {
    const normalized = value === "adminconfirm" ? "confirmed" : "pending";

    return (
      <span
        style={{
          display: "inline-block",
          padding: "4px 8px",
          borderRadius: "4px",
          fontSize: "12px",
          lineHeight: 1,
          background: normalized === "confirmed" ? "#f6ffed" : "#fff7e6",
          color: normalized === "confirmed" ? "#52c41a" : "#fa8c16",
          border: `1px solid ${
            normalized === "confirmed" ? "#b7eb8f" : "#ffd591"
          }`,
        }}
      >
        {normalized === "confirmed" ? "Confirmed" : "Pending"}
      </span>
    );
  },
},

  ];



  return (
     <div className="class-container">
         <Sidebar />
      <Header />
    <Card className="class-list-container">
 
      <div className="header-section">
      </div>

      <div className="cc-search-container">
        <Space size="middle" wrap>
        {userRole === "superadmin" && (
          <Select
            showSearch
            placeholder={t("Filter by branch")}
            value={selectedBranch}
            onChange={(value) => setSelectedBranch(value)}
            style={{ width: 200 }}
            allowClear
            optionFilterProp="children"
          >
            <Option value="">{t("All Branches")}</Option>
            {branches.map((branch) => (
              <Option key={branch.id} value={branch.id}>
                {branch.name}
              </Option>
            ))}
          </Select>
        )}
          {/* Date Picker */}
          <RangePicker
              format="DD MMM YYYY"
              value={[
                dateRange.startDate ? dayjs(dateRange.startDate) : null,
                dateRange.endDate ? dayjs(dateRange.endDate) : null,
              ]}
              onChange={(dates) => {
                setDateRange({
                  startDate: dates?.[0]
                    ? dates[0].format('YYYY-MM-DD')
                    : moment().utcOffset('+07:00').format('YYYY-MM-DD'),
                  endDate: dates?.[1]
                    ? dates[1].format('YYYY-MM-DD')
                    : moment().utcOffset('+07:00').format('YYYY-MM-DD'),
                });
              }}
              allowClear
              style={{ height: 32 }}
            />

          <Input
            prefix={
              <FontAwesomeIcon icon={faSearch} style={{ color: "#bfbfbf" }} />
            }
            placeholder={t("Search by Course, Subject or ID")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: 300 }}
            allowClear
          />

          <Select
            showSearch
            placeholder={t("Filter by teacher")}
            value={selectedTeacher}
            onChange={(value) => setSelectedTeacher(value)}
            style={{ width: 200 }}
            allowClear
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          >
            <Option value="" label={t("All Teachers")}>{t("All Teachers")}</Option>
            {teachers.map((teacher) => (
              <Option key={teacher.userid} value={teacher.userid} label={`${teacher.nickname} ${teacher.firstname}`}>
                {teacher.nickname} {teacher.firstname}
              </Option>
            ))}
          </Select>

   
            <CSVLink
              data={csvData}
              filename={`class_list_${moment().format("YYYY-MM-DD")}.csv`}
            >
              <Button
                type="primary"
                icon={<FontAwesomeIcon icon={faFileExcel} />}
              >
                {t("Export CSV")}
              </Button>
            </CSVLink>

            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={loading}
            >
              {t("Refresh")}
            </Button>
            <Button
              icon={<CloseOutlined />}
              onClick={handleClearFilters}
            >
              {t("Clear Filters")}
            </Button>

        </Space>
      </div>

      <Table
        dataSource={getCurrentPageData()}
        columns={columns}
        rowKey="classid"
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["50", "100", "200"],
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} items`
        }}
        onChange={handleTableChange}
        scroll={{ x: '100%' }}
        size="middle"
      />

    </Card>
         <Drawer
  title={`Attendance - ${selectedClass?.subject_name || ''}`}
  open={attendanceDrawerOpen}
  onClose={() => {
    setAttendanceDrawerOpen(false);
    setSelectedClass(null);
    setAttendance({});
    setHomework({});
    setEditMode({});
  }}
  width={900}
  placement="right"
>
  {/* Attendance Drawer Content */}
  {selectedClass && (
    <>
      {/* Class Information Header */}
      <div style={{ marginBottom: 24, padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
          <h3 style={{ margin: 0, color: '#1890ff' }}>
            <BookOutlined style={{ marginRight: 8 }} />
            {selectedClass.subject_name}
          </h3>
          <Tag color="blue">Class ID: {selectedClass.classid}</Tag>
        </div>
        <div style={{ display: 'flex', gap: 24, fontSize: 14, color: '#666' }}>
          <span>📅 {moment(selectedClass.date).format('DD-MMM-YYYY')}</span>
          <span>🕐 {formatTime(selectedClass.schedule_time)} - {calculateEndTime(selectedClass.schedule_time, selectedClass.schedule_hour)}</span>
          <span>👨‍🏫 {selectedClass.nickname}</span>
        </div>
      </div>

      {/* Students or Empty */}
      {registeredStudents.length === 0 ? (
        <Empty
          description="No students registered for this class"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ margin: '40px 0' }}
        >
          <Text type="secondary">
            Students need to be registered to this class group (Group ID: {selectedClass.groupid}) before attendance can be taken.
          </Text>
        </Empty>
      ) : (
        <>
          {/* Attendance Summary */}
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 16,
              }}
            >
              <h4 style={{ margin: 0 }}>
                Student Attendance ({registeredStudents.length} students)
              </h4>
              <div style={{ display: 'flex', gap: 8 }}>
                <Tag color="green">
                  Present: {registeredStudents.filter(s => savedAttendances[s.student_id]?.status === 'Present').length}
                </Tag>
                <Tag color="orange">
                  Late: {registeredStudents.filter(s => savedAttendances[s.student_id]?.status === 'Late').length}
                </Tag>
                <Tag color="red">
                  Absent: {registeredStudents.filter(s => savedAttendances[s.student_id]?.status === 'Absent').length}
                </Tag>
                <Tag color="purple">
                  To be rescheduled: {registeredStudents.filter(s => savedAttendances[s.student_id]?.status === 'To be rescheduled').length}
                </Tag>
                <Tag color="default">
                  Pending: {registeredStudents.filter(s => !savedAttendances[s.student_id]).length}
                </Tag>
              </div>
            </div>
          </div>

          {/* Students List */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {registeredStudents.map(student => {
                const savedRecord = savedAttendances[student.student_id];
                const currentAttendance = attendance[student.student_id];
                const inEdit = editMode[student.student_id];

                return (
                  <div
                    key={student.student_id}
                    style={{
                      border: '1px solid #e8e8e8',
                      borderRadius: 8,
                      padding: 16,
                      background: 'white',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    }}
                  >
                    {/* Student Header */}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 16,
                      }}
                    >
                      <div>
                        <h5 style={{ margin: 0, color: '#1890ff' }}>
                          {student.nickname}
                        </h5>
                        <span style={{ fontSize: 12, color: '#666' }}>
                          ID: {student.student_id}
                        </span>
                      </div>

                      {savedRecord && !inEdit && (
                          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <Tag
                              color={
                                savedRecord.status === "Present"
                                  ? "green"
                                  : savedRecord.status === "Late"
                                  ? "orange"
                                  : savedRecord.status === "To be rescheduled"
                                  ? "purple"
                                  : "red"
                              }
                            >
                              {savedRecord.status}
                            </Tag>

                            <Button
                              size="small"
                              icon={<EditOutlined />}
                              onClick={() => handleEdit(student.student_id)}
                            >
                              Edit
                            </Button>

                            <Button
                              size="small"
                              danger
                              icon={<CloseOutlined />}
                              onClick={() => handleDeleteAttendanceInDrawer(student.student_id)}
                            >
                              Delete
                            </Button>
                          </div>
                        )}

                    </div>

                    {/* Saved Record vs Edit Mode */}
                    {savedRecord && !inEdit ? (
                      /* Saved Record View */
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr 2fr',
                          gap: 16,
                          alignItems: 'flex-start',
                        }}
                      >
                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Homework Status
                          </label>
                          <div style={{ marginTop: 4 }}>
                            <Tag
                              color={
                                savedRecord.homework === 'YES'
                                  ? 'green'
                                  : savedRecord.homework === 'NO'
                                  ? 'red'
                                  : 'default'
                              }
                            >
                              {savedRecord.homework}
                            </Tag>
                          </div>
                        </div>

                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Timestamp
                          </label>
                          <div style={{ marginTop: 4, fontSize: 12 }}>
                            {moment(savedRecord.timestamp).format('DD-MMM-YYYY HH:mm')}
                            {savedRecord.edited_at && (
                              <div style={{ color: '#ff7a00', marginTop: 2 }}>
                                Edited: {moment(savedRecord.edited_at).format('DD-MMM-YYYY HH:mm')}
                              </div>
                            )}
                          </div>
                        </div>

                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Comments
                          </label>
                          <div style={{ marginTop: 4, fontSize: 14 }}>
                            {savedRecord.comment || (
                              <span style={{ color: '#bfbfbf' }}>No comments</span>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      /* Edit Mode */
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr 2fr 120px',
                          gap: 16,
                          alignItems: 'flex-start',
                        }}
                      >
                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Status
                          </label>
                          <Select
                            value={currentAttendance?.status ?? null}
                            onChange={value =>
                              handleAttendanceChange(student.student_id, 'status', value)
                            }
                            placeholder="Select Status"
                            style={{ width: '100%', marginTop: 4 }}
                          >
                            <Select.Option value="Present">{t('present')}</Select.Option>
                            <Select.Option value="Absent">{t('absent')}</Select.Option>
                            <Select.Option value="Late">{t('Late ≤ 15 M')}</Select.Option>
                            <Select.Option value="To be rescheduled">{t('toBeRescheduled')}</Select.Option>
                          </Select>
                        </div>

                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Homework
                          </label>
                          <Select
                            value={homework[student.student_id] ?? null}
                            onChange={value =>
                              handleHomeworkChange(student.student_id, value)
                            }
                            placeholder="Select Status"
                            style={{ width: '100%', marginTop: 4 }}
                          >
                            <Select.Option value="YES">YES</Select.Option>
                            <Select.Option value="NO">NO</Select.Option>
                            <Select.Option value="N/A">N/A</Select.Option>
                          </Select>
                        </div>

                        <div>
                          <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>
                            Comments
                          </label>
                          <Input.TextArea
                            vvalue={currentAttendance?.status ?? null}
                            onChange={e =>
                              handleAttendanceChange(student.student_id, 'comment', e.target.value)
                            }
                            placeholder="Add Comment"
                            rows={2}
                            style={{ marginTop: 4 }}
                          />
                        </div>

                        <div style={{ paddingTop: 20 }}>
                          <Button
                            type="primary"
                            onClick={() =>
                              inEdit
                                ? handleUpdate(student.student_id)
                                : handleSaveAttendance(student.student_id)
                            }
                            disabled={savingInProgress || !currentAttendance?.status}
                            icon={<SaveOutlined />}
                            block
                          >
                            {inEdit ? 'Update' : 'Save'}
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Quick Actions */}
          <div
            style={{
              marginTop: 24,
              padding: 16,
              background: '#f0f9ff',
              borderRadius: 8,
              border: '1px solid #bae7ff',
            }}
          >
            <h5 style={{ margin: 0, marginBottom: 8, color: '#1890ff' }}>Quick Actions</h5>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Button
                size="small"
                icon={<CheckCircleOutlined />}
                onClick={() => {
                  // Mark all as present
                  registeredStudents.forEach(student => {
                    if (!savedAttendances[student.student_id]) {
                      handleAttendanceChange(student.student_id, 'status', 'Present');
                    }
                  });
                }}
              >
                Mark All Present
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  )}
</Drawer>
<Modal
  title="Video Meeting Link"
  open={videoLinkModalOpen}
  onCancel={() => setVideoLinkModalOpen(false)}
  footer={[
    <Button key="cancel" onClick={() => setVideoLinkModalOpen(false)}>
      Cancel
    </Button>,
    <Button key="save" type="primary" onClick={saveVideoLink}>
      Save
    </Button>
  ]}
>
  <Input
    placeholder=""
    value={videoLink}
    onChange={(e) => setVideoLink(e.target.value)}
  />

  {existingVideoLink && (
    <Tag color="green" style={{ marginTop: 10 }}>
      Existing link found
    </Tag>
  )}
</Modal>

    </div>
  );
};

export default withRoleAccess(AllClassList, ["admin", "superadmin"]);